import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, DialogTitle, Snackbar } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { postDataWithResponse } from 'global/postFunc'
import { useEffect, useState } from 'react'

const TambahKelompok = ({ parentData, open, handleClose, decryptedUser, ta, kd_pd, kd_subkegiatan, updating, setUpdating }) => {
    const [uraian, setUraian] = useState('')
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        if (open) {
            console.log(parentData)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const [openSnackbar, setOpenSnackbar] = useState(false)
    const handleCloseSnackbar = () => {
        setOpenSnackbar(false)
    };

    const submit = (e) => {
        e.preventDefault();
        setSaving(true)
        postDataWithResponse(
            '/admin-opd/kelompok-paket/tambah',
            {
                ta: ta,
                kd_pd: kd_pd,
                kd_subkegiatan: kd_subkegiatan,
                kode_rekening_akun: parentData.kode,
                uraian_rekening_akun: parentData.uraian,
                uraian: uraian,
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUraian('')
                setOpenSnackbar(true)
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
        // console.log('submit');
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                component='form'
                onSubmit={submit}
            >
                <DialogTitle id="alert-dialog-title">
                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                        Tambah Pengelompokan Belanja / Paket Pekerjaan
                    </ArgonTypography>
                </DialogTitle>
                <DialogContent>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Uraian Pengelompokan Belanja / Paket Pekerjaan
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={uraian}
                            onChange={(e) => setUraian(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <ArgonButton
                        color='info'
                        variant='outlined'
                        size="small"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Batal
                    </ArgonButton>
                    <LoadingButton
                        color='info'
                        variant='contained'
                        size="small"
                        startIcon={<Save />}
                        type='submit'
                        loading={saving}
                    >
                        Simpan
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={1000}
                onClose={handleCloseSnackbar}
                message="Data Tersimpan"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            />
        </>
    )
}

export default TambahKelompok